/**
 * Balanced Header/Heeler helpers (team roping only).
 *
 * Mirrors the backend rule in
 * api_backend_fastify_server/src/domain/balanced-positions.ts. When an event
 * has `enforce_balanced_positions` on, a contestant's entries must split as
 * evenly as possible between Header and Heeler, which is expressed as a
 * per-side ceiling of `ceil(max_registrations_per_user / 2)`:
 *
 *     cap 2 -> 1 per side, cap 3 -> 2 per side, cap 4 -> 2 per side
 *
 * The server is the authority — everything here is advisory UX so a
 * contestant sees a greyed-out side instead of a 409 after submitting.
 */

/** Per-position ceiling implied by a total per-contestant entry cap. */
export function maxEntriesPerPosition(totalCap: number): number {
  const cap = Number.isFinite(totalCap) ? Math.floor(totalCap) : 1;
  return Math.ceil(Math.max(1, cap) / 2);
}

/** Human-readable summary of the rule for a given cap, e.g. "1 Header + 1 Heeler". */
export function describeBalancedSplit(totalCap: number): string {
  const perSide = maxEntriesPerPosition(totalCap);
  const other = totalCap - perSide;
  return other === perSide
    ? `${perSide} Header + ${perSide} Heeler`
    : `${perSide} of one position and ${other} of the other`;
}
